import { Controller } from "@hotwired/stimulus"
import { selectAll, setSelectedValues } from "../../shared/multi_select"

export default class extends Controller {
  static values = {
    allNoHongHe: Array,
    allNoHKHongHe: Array,
    creative: Array,
    creativeNoHongHe: Array,
    creativeNoHKHongHe: Array
  }
  static targets = ["selectCtl"]

  select_all(event) {
    event.preventDefault()
    selectAll(this.selectCtlTarget)
  }

  select_creative(event) {
    event.preventDefault()
    this.addSelectedValues(this.creativeValue)
  }

  select_creative_no_honghe(event) {
    event.preventDefault()
    this.addSelectedValues(this.creativeNoHongHeValue)
  }

  select_creative_no_hk_honghe(event) {
    event.preventDefault()
    this.addSelectedValues(this.creativeNoHKHongHeValue)
  }

  select_all_no_honghe(event) {
    event.preventDefault()
    this.addSelectedValues(this.allNoHongHeValue)
  }

  select_all_no_hk_honghe(event) {
    event.preventDefault()
    this.addSelectedValues(this.allNoHKHongHeValue)
  }

  addSelectedValues(values) {
    const selectedValues = Array.from(this.selectCtlTarget.selectedOptions, (option) => option.value)
    setSelectedValues(this.selectCtlTarget, [...new Set(selectedValues.concat(values.map(String)))])
  }
}
